import {
  CONSIGNOR_RETURN_CREATE_TYPE_LIST,
  CONSIGNOR_RETURN_SHIPMENT_TYPE
} from 'domains/seller-outbound-return/constants'
import * as Yup from 'yup'

Yup.addMethod(Yup.array, 'unique', function(message, mapper = (a) => a) {
  return this.test('unique', message, function(list) {
    if (!Array.isArray(list)) return true
    return list.length === new Set(list.map(mapper)).size
  })
})

const createReturnTypes = CONSIGNOR_RETURN_CREATE_TYPE_LIST.map((option) => option.value)
const createShipmentTypes = Object.values(CONSIGNOR_RETURN_SHIPMENT_TYPE).map((option) => option.value)

const sellerOutboundReturnCreateSchema = Yup.object().shape({
  seller_id   : Yup.number().required('Consignor is required'),
  return_type : Yup.string().oneOf(
    createReturnTypes,
    `Must be one of this value: ${createReturnTypes.join(', ')}`
  ).required('Return Type is required'),
  shipment_type: Yup.string().oneOf(
    createShipmentTypes,
    `Must be one of this value: ${createShipmentTypes.join(', ')}`
  ).required('Shipment Type is required'),
  allow_unowned_items: Yup.boolean(),
  items: Yup.array()
    .of(
      Yup.object().shape({
        inventory_id      : Yup.number().required('Required'),
        sku               : Yup.string().required('Required'),
        quantity          : Yup.number().integer('Must be integer').min(1, 'Minimum 1').required('Required'),
        max_quantity      : Yup.number().integer('Must be integer').min(1, 'Minimum 1'),
        sellable_quantity : Yup.number().min(0, 'Sellable Quantity can be 0 for Consignor Return'),
        stored_quantity   : Yup.number().min(1, 'Inventory Quantity must be available for Consignor Return')
      }))
    .unique('Setiap inventory return harus unik', (item) => `${item.inventory_id}-${item.sku}`)
    .min(1, 'Minimum one item is filled')
    .required('Required')
})

export default sellerOutboundReturnCreateSchema